import React from 'react';
import dt from "date-and-time";
import dateFormat from "dateformat";
import { date_util } from "noood/util/date/DateUtil";
export var DateFormatter = {
  // source_format
  /*
    token 	meaning 	examples of output
   YYYY 	four-digit year 	0999, 2015
   YY 	two-digit year 	99, 01, 15
   Y 	four-digit year without zero-padding 	2, 44, 888, 2015
   MMMM 	month name (long) 	January, December
   MMM 	month name (short) 	Jan, Dec
   MM 	month with zero-padding 	01, 12
   M 	month 	1, 12
   DD 	date with zero-padding 	02, 31
   D 	date 	2, 31
   dddd 	day of week (long) 	Friday, Sunday
   ddd 	day of week (short) 	Fri, Sun
   dd 	day of week (very short) 	Fr, Su
   HH 	24-hour with zero-padding 	23, 08
   H 	24-hour 	23, 8
   hh 	12-hour with zero-padding 	11, 08
   h 	12-hour 	11, 8
   A 	meridiem (uppercase) 	AM, PM
   mm 	minute with zero-padding 	14, 07
   m 	minute 	14, 7
   ss 	second with zero-padding 	05, 10
   s 	second 	5, 10
   SSS 	millisecond (high accuracy) 	753, 022
   SS 	millisecond (middle accuracy) 	75, 02
   S 	millisecond (low accuracy) 	7, 0
   Z 	time zone offset value 	+0100, -0800
   ZZ 	time zone offset value with colon 	+01:00, -08:00
    output_format dateFormat
    d 	Day of the month as digits; no leading zero for single-digit days.
   dd 	Day of the month as digits; leading zero for single-digit days.
   ddd 	Day of the week as a three-letter abbreviation.
   DDD 	"Ysd", "Tdy" or "Tmw" if date lies within these three days. Else fall back to ddd.
   dddd 	Day of the week as its full name.
   DDDD 	"Yesterday", "Today" or "Tomorrow" if date lies within these three days. Else fall back to dddd.
   m 	Month as digits; no leading zero for single-digit months.
   mm 	Month as digits; leading zero for single-digit months.
   mmm 	Month as a three-letter abbreviation.
   mmmm 	Month as its full name.
   yy 	Year as last two digits; leading zero for years less than 10.
   yyyy 	Year represented by four digits.
   h 	Hours; no leading zero for single-digit hours (12-hour clock).
   hh 	Hours; leading zero for single-digit hours (12-hour clock).
   H 	Hours; no leading zero for single-digit hours (24-hour clock).
   HH 	Hours; leading zero for single-digit hours (24-hour clock).
   M 	Minutes; no leading zero for single-digit minutes.
   MM 	Minutes; leading zero for single-digit minutes.
   N 	ISO 8601 numeric representation of the day of the week.
   o 	GMT/UTC timezone offset, e.g. -0500 or +0230.
   p 	GMT/UTC timezone offset, e.g. -05:00 or +02:30.
   s 	Seconds; no leading zero for single-digit seconds.
   ss 	Seconds; leading zero for single-digit seconds.
   S 	The date's ordinal suffix (st, nd, rd, or th). Works well with d.
   l 	Milliseconds; gives 3 digits.
   L 	Milliseconds; gives 2 digits.
   t 	Lowercase, single-character time marker string: a or p.
   tt 	Lowercase, two-character time marker string: am or pm.
   T 	Uppercase, single-character time marker string: A or P.
   TT 	Uppercase, two-character time marker string: AM or PM.
   W 	ISO 8601 week number of the year, e.g. 4, 42
   WW 	ISO 8601 week number of the year, leading zero for single-digit, e.g. 04, 42
   Z 	US timezone abbreviation, e.g. EST or MDT. For non-US timezones, the GMT/UTC offset is returned, e.g. GMT-0500
   '...', "..." 	Literal character sequence. Surrounding quotes are removed.
   UTC: 	Must be the first four characters of the mask. Converts the date from local time to UTC/GMT/Zulu time before applying the mask. The "UTC:" prefix is removed.
    default 	ddd mmm dd yyyy HH:MM:ss 	Sat Jun 09 2007 17:46:21
   shortDate 	m/d/yy 	6/9/07
   paddedShortDate 	mm/dd/yyyy 	06/09/2007
   mediumDate 	mmm d, yyyy 	Jun 9, 2007
   longDate 	mmmm d, yyyy 	June 9, 2007
   fullDate 	dddd, mmmm d, yyyy 	Saturday, June 9, 2007
   shortTime 	h:MM TT 	5:46 PM
   mediumTime 	h:MM:ss TT 	5:46:21 PM
   longTime 	h:MM:ss TT Z 	5:46:21 PM EST
   isoDate 	yyyy-mm-dd 	2007-06-09
   isoTime 	HH:MM:ss 	17:46:21
   isoDateTime 	yyyy-mm-dd'T'HH:MM:sso 	2007-06-09T17:46:21+0700
   isoUtcDateTime 	UTC:yyyy-mm-dd'T'HH:MM:ss'Z' 	2007-06-09T22:46:21Z
    */

  SQL: "YYYY-MM-DD HH:mm:ss",
  SQL_DATETIME: "YYYY-MM-DD HH:mm:ss",
  SQL_DATE: "YYYY-MM-DD",
  SQL_TIME: "HH:mm:ss",
  format: function format(date_str, source_format, output_format) {
    if (date_str) {
      var _date_str$toString;
      // alert(`will parse ${date_str} with format of ${source_format} to format ${output_format}`)
      var date_obj = dt.parse(date_str === null || date_str === void 0 || (_date_str$toString = date_str.toString()) === null || _date_str$toString === void 0 ? void 0 : _date_str$toString.trim(), source_format);
      if (!isNaN(date_obj)) {
        return dateFormat(date_obj, output_format);
      }
      throw new Error('date_parse_error');
    }
    return null;
  },
  format_sql_time: function format_sql_time(_ref) {
    var time_str = _ref.time_str,
      desired_format = _ref.desired_format;
    if (time_str === void 0 || time_str === null) return '';
    // create a supplementary date so we can format the time
    var supplementary_date = date_util.now('yyyy-mm-dd') + ' ' + time_str;
    return date_util.reformat(supplementary_date, DateFormatter.SQL, desired_format !== null && desired_format !== void 0 ? desired_format : 'hh:MM tt');
  }
};